<template>
  <div class="modal-mask align-content-center">
    <div class="modal-wrapper">
      <div class="modal-container scrollable">
        <div class="modal-title warning-title">
            <smtt-icon icon="exclamation-triangle" class="align-middle mr-4" color="#FFAA00"/>
            <slot name="title"></slot>
        </div>
        <div class="modal-body">
            <slot name="body"></slot>
        </div>
        <div class="d-flex justify-content-end px-5 pb-3">
            <app-button btn-type="ghost" variation="regular" class="mr-4" @click="$emit('onCancel')">
                {{ $t('confirmResultModal.cancel.label') }}
            </app-button>
            <app-button variation="warning" @click="$emit('onConfirm')">
                {{ $t('confirmResultModal.confirm.label') }}
            </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton';

export default {
  name: 'ConfirmModal',
  components: { AppButton },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  transition: opacity 0.3s ease;
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 370px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  z-index: 1000;
}

.scrollable {
  overflow: auto;
  max-height: 90vh;
}

.fixed-row .col,.col--auto {
  height: 24px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.warning-title {
  background-color: #FFEECC;
  color: #5C3D00;
  font-weight: 700;
  padding: 8px 16px;
  font-size: 18px;
}

</style>